import { render, staticRenderFns } from "./FormFolders.vue?vue&type=template&id=062ae4a7&"
import script from "./FormFolders.vue?vue&type=script&lang=js&"
export * from "./FormFolders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports